import "../../_namespaces.js";
import "../../_generated_templates.js";
window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.Assessment = class Assessment extends Backbone.View {
  static Pages = {
    INTRO: "intro",
    SUBMITTER_INFO: "submitter_info",
    DONE: "end", // This must match the builder value since users can pick it as a target
  };

  static {
    this.prototype.tagName = "div";
    this.prototype.className = "assessment-viewer";

    this.prototype.template = _.template(AssessmentViewer.Templates.Assessment.assessment);

    this.prototype.events = {
      [AssessmentViewer.Events.AssessmentNavigation.beginClicked]: "handleBeginClicked",
      [AssessmentViewer.Events.AssessmentNavigation.previousClicked]: "handlePreviousClicked",
      [AssessmentViewer.Events.AssessmentNavigation.nextClicked]: "handleNextClicked",
      [AssessmentViewer.Events.Response.selected]: "handleResponseSelected",
      [AssessmentViewer.Events.SubmitterInfo.changed]: "handleSubmitterInfoChanged",
    };
  }

  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.renderPage = this.renderPage.bind(this);
    this.renderIntroPage = this.renderIntroPage.bind(this);
    this.renderQuestion = this.renderQuestion.bind(this);
    this.renderScore = this.renderScore.bind(this);
    this.renderProgress = this.renderProgress.bind(this);
    this.renderNavigation = this.renderNavigation.bind(this);
    this.renderCompletionPage = this.renderCompletionPage.bind(this);
    this.renderSubmitterInfo = this.renderSubmitterInfo.bind(this);
    this.pageForward = this.pageForward.bind(this);
    this.pageBack = this.pageBack.bind(this);
    this.continueTo = this.continueTo.bind(this);
    this.resetHistory = this.resetHistory.bind(this);
    this.resetPage = this.resetPage.bind(this);
    this.hasStarted = this.hasStarted.bind(this);
    this.isDone = this.isDone.bind(this);
    this.canReverse = this.canReverse.bind(this);
    this.canAdvance = this.canAdvance.bind(this);
    this.canAdvanceWithoutChoosingResponse = this.canAdvanceWithoutChoosingResponse.bind(this);
    this.canAdvancePastSubmitterInfo = this.canAdvancePastSubmitterInfo.bind(this);
    this.firstPage = this.firstPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.nextPageFromResponse = this.nextPageFromResponse.bind(this);
    this.nextPageWithoutChoosingResponse = this.nextPageWithoutChoosingResponse.bind(this);
    this.nextSequentialPage = this.nextSequentialPage.bind(this);
    this.nextPageFromResponsePage = this.nextPageFromResponsePage.bind(this);
    this.postQuestionPage = this.postQuestionPage.bind(this);
    this.nextQuestionsFromResponses = this.nextQuestionsFromResponses.bind(this);
    this.getQuestion = this.getQuestion.bind(this);
    this.isPageQuestion = this.isPageQuestion.bind(this);
    this.getCurrentStep = this.getCurrentStep.bind(this);
    this.getSteps = this.getSteps.bind(this);
    this.isSubmitterInfoPosition = this.isSubmitterInfoPosition.bind(this);
    this.isIntroEnabled = this.isIntroEnabled.bind(this);
  }

  initialize(options = {}) {
    this.options = options;
    this.resetHistory();
    this.currentPage = this.firstPage();
    return (this.progress = new Backbone.Model());
  }

  render() {
    this.$el.append(this.template(this.model.attributes));
    this.renderPage(this.currentPage);

    return this;
  }

  renderPage(page) {
    switch (page) {
      case this.constructor.Pages.INTRO:
        this.currentPage = page;
        this.renderIntroPage();
        break;
      case this.constructor.Pages.SUBMITTER_INFO:
        this.currentPage = page;
        this.renderSubmitterInfo();
        break;
      case this.constructor.Pages.DONE:
        this.currentPage = page;
        this.renderScore();
        this.$el.trigger(AssessmentViewer.Events.Assessment.completed);
        break;
      case null:
      case undefined:
        throw "Can't show blank page";
        break;
      default:
        this.currentPage = page;
        this.renderQuestion();
    }

    this.progress.set({ current: this.getCurrentStep(), total: this.getSteps().length });
    this.renderProgress();
    return this.renderNavigation();
  }

  renderIntroPage() {
    const view = new AssessmentViewer.Views.AssessmentIntro({ model: this.model });
    return this.$(".content-container").html(view.render().el);
  }

  renderQuestion() {
    const view = new AssessmentViewer.Views.Question({ model: this.currentPage });
    return this.$(".content-container").html(view.render().el);
  }

  renderScore() {
    let page;
    const score = this.model.calculateScore();
    if (score != null) {
      page = this.model.completionPageForScore(score);
    }

    if (!page) {
      return this.renderCompletionPage(this.model.get("completionPageContent"), score);
    } else if (page.redirects()) {
      return this.redirectToCustomCompletionPage(page, score);
    } else {
      return this.renderCompletionPage(page.get("text"), score);
    }
  }

  renderProgress() {
    const view = new AssessmentViewer.Views.AssessmentProgress({ model: this.progress });

    return this.$(".progress-container").html(view.render().el);
  }

  renderNavigation() {
    const view = new AssessmentViewer.Views.AssessmentNavigation({
      begin: !this.hasStarted(),
      previous: this.canReverse(),
      next: this.canAdvance(),
      startOver: false, // This is will likely change since we are going to make changes to how custom redirects work.
      end: this.isDone(),
    });

    return this.$(".navigation-container").html(view.render().el);
  }

  renderCompletionPage(text, score) {
    const view = new AssessmentViewer.Views.AssessmentDone({ model: new Backbone.Model({ text, score }) });
    return this.$(".content-container").html(view.render().el);
  }

  renderSubmitterInfo() {
    // Reinstantiate the view so event handlers are reattached
    this.submitterInfoView = new AssessmentViewer.Views.AssessmentSubmitterInfo({ model: this.model });
    return this.$(".content-container").html(this.submitterInfoView.render().el);
  }

  // EVENT HANDLERS

  handleBeginClicked() {
    return this.pageForward();
  }

  handlePreviousClicked() {
    return this.pageBack();
  }

  handleNextClicked() {
    return this.pageForward();
  }

  handleResponseSelected() {
    return this.renderNavigation();
  }

  handleSubmitterInfoChanged() {
    return this.renderNavigation();
  }

  // PAGE TRAVERSING

  pageForward() {
    return this.continueTo(this.nextPage());
  }

  pageBack() {
    if (this.isPageQuestion(this.currentPage)) {
      this.currentPage.resetResponses();
    }
    return this.renderPage(this.pageHistory.pop());
  }

  continueTo(page) {
    this.pageHistory.push(this.currentPage);
    return this.renderPage(page);
  }

  resetHistory() {
    return (this.pageHistory = []);
  }

  resetPage() {
    return (this.currentPage = null);
  }

  // STATE

  hasStarted() {
    return this.currentPage && this.currentPage !== this.constructor.Pages.INTRO;
  }

  isDone() {
    return this.currentPage === this.constructor.Pages.DONE;
  }

  // PAGE TRAVERSING CONDITIONS

  canReverse() {
    return this.pageHistory.length && !this.isDone();
  }

  canAdvance() {
    if (this.currentPage === this.constructor.Pages.SUBMITTER_INFO) {
      return this.canAdvancePastSubmitterInfo();
    } else if (this.hasStarted() && !this.isDone()) {
      return this.nextPage();
    }
  }

  canAdvanceWithoutChoosingResponse() {
    return !this.currentPage.get("required") && this.nextQuestionsFromResponses().length < 2;
  }

  canAdvancePastSubmitterInfo() {
    return this.submitterInfoView.validateSubmitterInfo();
  }

  // PAGE ORDER

  firstPage() {
    return this.getSteps()[0];
  }

  nextPage() {
    if (this.currentPage === this.constructor.Pages.INTRO && this.isSubmitterInfoPosition("before")) {
      return this.constructor.Pages.SUBMITTER_INFO;
    } else if (this.currentPage === this.constructor.Pages.INTRO && !this.isSubmitterInfoPosition("before")) {
      return this.model.get("questions").at(0);
    } else if (this.currentPage === this.constructor.Pages.SUBMITTER_INFO && this.isSubmitterInfoPosition("before")) {
      return this.model.get("questions").at(0);
    } else if (this.currentPage === this.constructor.Pages.SUBMITTER_INFO && this.isSubmitterInfoPosition("after")) {
      return this.constructor.Pages.DONE;
    } else if (this.isPageQuestion(this.currentPage) && this.currentPage.hasSelectedResponse()) {
      return this.nextPageFromResponse() || this.nextSequentialPage() || this.postQuestionPage();
    } else if (this.isPageQuestion(this.currentPage) && this.canAdvanceWithoutChoosingResponse()) {
      return this.nextPageWithoutChoosingResponse() || this.nextSequentialPage() || this.postQuestionPage();
    } else {
      return;
    }
  }

  nextPageFromResponse() {
    // Assume multiple responses all have the same next question
    return this.nextPageFromResponsePage(this.currentPage.get("responses").firstSelected().get("nextQuestion"));
  }

  nextPageWithoutChoosingResponse() {
    return this.nextPageFromResponsePage(this.nextQuestionsFromResponses()[0]);
  }

  nextSequentialPage() {
    return this.model.get("questions").findWhere({ position: this.currentPage.get("position") + 1 });
  }

  nextPageFromResponsePage(page) {
    if (page === this.constructor.Pages.DONE) {
      return this.postQuestionPage();
    } else {
      return this.getQuestion(page);
    }
  }

  postQuestionPage() {
    if (this.isSubmitterInfoPosition("after")) {
      return this.constructor.Pages.SUBMITTER_INFO;
    } else {
      return this.constructor.Pages.DONE;
    }
  }

  // HELPER FUNCTIONS

  nextQuestionsFromResponses() {
    return _.unique(this.currentPage.get("responses").pluck("nextQuestion"));
  }

  redirectToCustomCompletionPage(completionPage, score) {
    const form = jQuery("<form>", { action: completionPage.get("url"), method: "get" });
    if (score) {
      form.append(jQuery("<input>", { type: "hidden", name: "assessment_score", value: score }));
    }
    return form.appendTo("body").trigger("submit");
  }

  getQuestion(id) {
    return this.model.get("questions").get(id);
  }

  isPageQuestion(page) {
    return page instanceof AssessmentViewer.Models.Question;
  }

  getCurrentStep() {
    return this.getSteps().indexOf(this.currentPage) + 1;
  }

  getSteps() {
    let steps = [];
    if (this.isIntroEnabled()) {
      steps.push(this.constructor.Pages.INTRO);
    }
    if (this.isSubmitterInfoPosition("before")) {
      steps.push(this.constructor.Pages.SUBMITTER_INFO);
    }
    steps = steps.concat(this.model.attributes.questions.toArray());
    if (this.isSubmitterInfoPosition("after")) {
      steps.push(this.constructor.Pages.SUBMITTER_INFO);
    }
    steps.push(this.constructor.Pages.DONE);

    return steps;
  }

  isSubmitterInfoPosition(position) {
    return !this.options.hideSubmitterInfo && this.model.get("submitterInfo").position === position;
  }

  isIntroEnabled() {
    return this.model.get("intro").enabled;
  }
};
